import { observer } from "mobx-react";
import { classNames } from "primereact";
import React from "react";
import { useForm } from "react-hook-form";
import { screenSize, useMediaQuery } from "../../hooks/responsiveLayout";
import ContactGroupStore from "../../store/ContactGroupStore";
import ContactGroupListCard from "./ContactGroupListCard";
import ContactGroupSettings from "./contactGroupSettings/ContactGroupSettings";

const ContactGroupView: React.FC = () => {
  const contactGroups = ContactGroupStore.contactGroups;
  const currentContactGroupId = ContactGroupStore.currentContactGroupId;
  const useFormMethods = useForm();
  const [width] = useMediaQuery();

  const currentContactGroup = contactGroups.find(
    (group) => group.id === currentContactGroupId
  );

  return (
    <div className="deviceview-container p-grid">
      <div
        className={classNames("deviceview-content", {
          "p-jc-center": width < screenSize.tablet,
          "p-px-3": width >= screenSize.tablet,
        })}
      >
        <ContactGroupListCard
          useFormMethods={useFormMethods}
          contactGroups={contactGroups}
        />
        {currentContactGroupId && (
          <div className="device-detail">
            {currentContactGroup && (
              <ContactGroupSettings currentContactGroup={currentContactGroup} />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default observer(ContactGroupView);
